import {Injectable} from '@angular/core';
import {ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from "rxjs";
import {UserRoles} from "../user/user-roles";
import {RouteData} from "../shared/services/route-data/route-data";
import * as fromStore from '../store';
import {filter, first, switchMap} from "rxjs/operators";
import {User} from '../user/user';
import {DbStoreState} from '../store/reducers';
import {Store} from '@ngrx/store';
import {UserSubscriptionCategory} from "../user/user-subscription";

@Injectable()
export class StarterGuard implements CanActivate {

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _store: Store<DbStoreState>,
  ) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return new Promise<boolean>((resolve, reject) => {
      this._store.select(fromStore.getUserLoaded)
        .pipe(
          filter((loaded: boolean) => loaded),
          switchMap(() => this._store.select(fromStore.getUser)),
          first()
        )
        .subscribe((user: User) => {
          const role: string = user ? UserRoles.user : UserRoles.guest;
          const routeData: RouteData = new RouteData(next.data);


          if (user && user.planType !== UserSubscriptionCategory.STARTER) {
            this._router.navigate(['/websites']);
            resolve(true);

          }
          resolve(false);
        });
    });
  }


}
